// extracted by mini-css-extract-plugin
module.exports = {"Links":"menu_Links__gX9bF"};